import { useRef, useState } from "react";
import { Card } from "primereact/card";
import { TabView, TabPanel } from "primereact/tabview";
import { Button } from "primereact/button";
import { Tag } from "primereact/tag";
import SessionsCarousel from "../../../../../../../components/sharedComponents/SessionsCarousel";
import { Divider } from "primereact/divider";
import { ProgressBar } from "primereact/progressbar";
import { InputText } from "primereact/inputtext";
import JWVideoPlayer from "../../../../../../../components/sharedComponents/JwVideoPlayer";
import ReactPlayer from "react-player";
import { InputTextarea } from "primereact/inputtextarea";
import { ProgressSpinner } from "primereact/progressspinner";
import SaveBookmarkPopup from "../../../SaveBookmarkPopup";
import audioFile from "../../../../../../../assets/stg-GM-it0wD-1458-119043.mp3";
import audioOnlySession from "../../../../../../../assets/images/audio_only_session.png";
import { bottom } from "@popperjs/core";
import AllTaskQuestionViewComponent from "../AllTaskQuestionViewComponent/AllTaskQuestionViewComponent";

const transcriptSelections = [
  {
    label: "Transcript & Topics/keywords",
    value: "Transcript & Topics/keywords",
  },
  {
    label: "Sentiments/Emotions & Entities",
    value: "Sentiments/Emotions & Entities",
  },
];

const breadcrumbsItems = [
  { label: "Scrub Daddy (11)" },
  { label: "Eye Holes (3)" },
  { label: "Eye Holes (1)" },
  { label: "Eye Holes (4)" },
  { label: "Eye Holes (9)" },
];

const VideoAudioXmotType = ({ isAudioSession = false }) => {
  const [selectedSession, setSelectedSession] = useState(0);
  const [selectedTranscript, setSelectedTranscript] = useState(
    "Transcript & Topics/keywords",
  );
  const [showPlayerFullView, setShowPlayerFullView] = useState(false);
  const [showBookmarkPopup, setShowBookmarkPopup] = useState(false);
  const [isVideoStartPlaying, setIsVideoStartPlaying] = useState(false);
  const playerRef = useRef(null);
  const [played, setPlayed] = useState(0); // 0–1 fraction
  const [duration, setDuration] = useState(0);
  const [allTQToggle, setAllTQToggle] = useState(false);

  const sessions = [
    { id: 1, name: "Wendoline S", title: "Cooking In Your Home" },
    { id: 2, name: "Alex Q", title: "Cooking In Your Home" },
    { id: 3, name: "Ira D", title: "Cooking In Your Home" },
    { id: 4, name: "Jesseca A", title: "Cooking In Your Home" },
    { id: 5, name: "Jeff B", title: "Cooking In Your Home" },
    { id: 6, name: "Kimberlee C", title: "Cooking In Your Home" },
    { id: 7, name: "Bobby S", title: "Cooking In Your Home" },
    { id: 8, name: "Bobby S", title: "Cooking In Your Home" },
    { id: 9, name: "Bobby S", title: "Cooking In Your Home" },
    { id: 10, name: "Bobby S", title: "Cooking In Your Home" },
  ];

  return (
    <div className="video-xmot-type p-4">
      {isAudioSession ? (
        <>
          <h5 className="text_dark fw-600">Summary</h5>
          <p>
            The past few weeks with the product for the most part it went. Okay.
            I've used quite a bit of the spruce grass and weed killer throughout
            my lawn mostly in the landscaping to get rid of weeds. I'm at least
            kill them before I would pick them. It doesn't feel like it's as
            effective as some of the more powerful products and not natural
            products, but it does cause the weeds to wilt and die eventually
            just takes a little more time is what I've been.
          </p>

          <section className="mt-5 filter-by-theme">
            <h5 className="text_dark fw-600">Filter By Theme:</h5>
            <div className="button-group my-3">
              <Button
                label="Skincare Experimentation"
                className="filter-button-text me-3"
              />
              <Button
                label="Brand And Price Considerations"
                className="filter-button-text me-3"
              />
              <Button
                label="Recommendations And Endorsements"
                className="filter-button-text"
              />
            </div>
            <Divider />
          </section>
        </>
      ) : (
        ""
      )}
      <section className="session-slides mt-3">
        <div>
          <h5 className="mb-3">Sessions</h5>
          <SessionsCarousel
            selectedSession={selectedSession}
            setSelectedSession={setSelectedSession}
            sessionsData={sessions}
          />
        </div>

        <div className="displayLabels mt-3">
          <div className="row m-0">
            <div className="col-lg-3 col-md-3 col-3 videoDetailsPanel">
              <div className="fs-12 fw-600 title">Session Name</div>
              <strong id="info_sn">New M_01 (V-220805-189)</strong>
            </div>
            <div className="col-lg-2 col-md-2 col-2 videoDetailsPanel">
              <div className="fs-12 fw-600 title">Participant Name</div>
              <strong id="info_ptn">New Meet</strong>
            </div>
            <div className="col-lg-2 col-md-2 col-2 videoDetailsPanel">
              <div className="fs-12 fw-600 title">Participant ID</div>
              <strong id="info_ptid">12853</strong>
            </div>
            <div className="col-lg-1 col-md-1 col-1 videoDetailsPanel">
              <div className="fs-12 fw-600 title">Age</div>
              <strong id="info_age">55</strong>
            </div>
            <div className="col-lg-1 col-md-1 col-1 videoDetailsPanel">
              <div className="fs-12 fw-600 title">Gender</div>
              <strong id="info_gender">-</strong>
            </div>
            <div className="col-lg-3 col-md-3 col-3 videoDetailsPanel">
              <div className="fs-12 fw-600 title">Location</div>
              <strong id="info_city">Cincinnati, United States</strong>
            </div>
          </div>
        </div>
      </section>
      <section className="my-3">
        <div className="row m-0">
          {/* LEFT SECTION - IMAGE + QUESTION */}
          <div className={showPlayerFullView ? "col-md-12" : "col-md-7"}>
            <Card className="p-0 shadow-sm">
              <div className="position-relative">
                {/* <img
                  src="https://via.placeholder.com/800x400"
                  alt="Living room example"
                  className="img-fluid rounded-top"
                />
                <Button
                  icon="pi pi-bookmark"
                  className="p-button-rounded p-button-secondary position-absolute"
                  style={{ top: "10px", left: "10px" }}
                /> */}
                {/* <JWVideoPlayer
                  library="https://cdn.jwplayer.com/libraries/vPOmcF3l.js"
                  file="../../../../../../../../smartpanel_frontend_app/video_test.mp4"
                  // image="https://cdn.jwplayer.com/thumbs/your-thumbnail.jpg"
                  config={{
                    autostart: true,
                    repeat: false,
                    controls: true,
                  }}
                /> */}
                <ReactPlayer
                  ref={playerRef}
                  className="w-100"
                  style={{ height: showPlayerFullView ? "85vh" : "500px" }}
                  src={
                    isAudioSession
                      ? audioFile
                      : "https://www.youtube.com/watch?v=LXb3EKWsInQ"
                  }
                  controls
                  onTimeUpdate={(e) => console.log(e.target.value)}
                />
                {isAudioSession ? (
                  <>
                    <div
                      className="audio-overlay"
                      style={{
                        width: "100%",
                        height: "90%",
                        backgroundColor: "rgb(241, 241, 241)",
                        textAlign: "center",
                        position: "absolute",
                        top: 0,
                        left: 0,
                      }}
                    >
                      <img src={audioOnlySession} />
                    </div>
                  </>
                ) : (
                  ""
                )}

                {/* Overlay timeline */}
                {/* <input
                  type="range"
                  min={0}
                  max={1}
                  step="0.001"
                  value={played}
                  onChange={(e) => {
                    const newPlayed = parseFloat(e.target.value);
                    setPlayed(newPlayed);
                    playerRef.current.seekTo(newPlayed, "fraction");
                  }}
                  style={{
                    position: "absolute",
                    bottom: "10px",
                    left: "20px",
                    right: "20px",
                    width: "calc(100% - 40px)",
                    zIndex: 10,
                    appearance: "none",
                    height: "6px",
                    background: "#ffffff66",
                    borderRadius: "5px",
                  }}
                /> */}

                <Button
                  className="toggle-content-btn"
                  onClick={() => setShowPlayerFullView(!showPlayerFullView)}
                >
                  <i className="pi pi-window-maximize"></i>
                </Button>

                <div
                  className={
                    showBookmarkPopup
                      ? "save-bookmark save-bookmark-popup-open"
                      : "save-bookmark"
                  }
                >
                  {showBookmarkPopup ? (
                    <SaveBookmarkPopup
                      setShowBookmarkPopup={setShowBookmarkPopup}
                    />
                  ) : (
                    <Button
                      className="save-bookmark-btn d-flex flex-column"
                      onClick={() => setShowBookmarkPopup(true)}
                    >
                      <div>
                        <i className="pi pi-bookmark-fill" />
                      </div>
                      <div>Save</div>
                    </Button>
                  )}
                </div>
              </div>
              <AllTaskQuestionViewComponent
                allTQToggle={allTQToggle}
                handleAllTQToggle={(toggleValue) => setAllTQToggle(toggleValue)}
              />
            </Card>
          </div>

          {/* RIGHT SECTION - TRANSCRIPT & KEYWORDS */}
          <div className={showPlayerFullView ? "d-none" : "col-md-5"}>
            {/* <Card className="shadow-sm"> */}
            <TabView className="transcript-tabs">
              <TabPanel header="Transcript & Keywords" className="p-0">
                <div className="button-group d-flex align-items-center mt-3 mb-2">
                  {transcriptSelections?.map((transcriptSelection, i) => {
                    return (
                      <div key={i}>
                        <Button
                          label={transcriptSelection.label}
                          onClick={() =>
                            setSelectedTranscript(transcriptSelection.value)
                          }
                          className={`transcript-button-text me-3 fs-14 ${selectedTranscript === transcriptSelection.value ? "active" : ""}`}
                        />
                      </div>
                    );
                  })}
                </div>
                <Divider />

                {selectedTranscript === "Transcript & Topics/keywords" ? (
                  <div>
                    <TabView className="transcript-tabs">
                      <TabPanel header="Transcript" className="p-0">
                        <InputText
                          name={`transcript_search`}
                          value={""}
                          className="transcript-search my-2 w-100"
                          placeholder={"Search"}
                        />

                        <div
                          className="transcript-area"
                          style={{
                            height: "400px",
                            overflow: "auto",
                          }}
                        >
                          Okay. So the first question is, what type of cleaning
                          tools? Do you currently use to wash your dishes in
                          your sink? So I'm really embarrassed to admit that
                          sponges are kind of the same to me. They get smelly,
                          they get kind of stinky, you have to throw them away.
                          I actually try to sanitize them in the microwave
                          because that's supposed to be a hack. So I ended up
                          buying like a Honey pack for 10 bucks through Amazon,
                          some off-brand. Now, the thing that my husband uses a
                          lot is that wand where you put the detergent in. So
                          used to be a Scotch Brite brand and then they decide
                          to come out with a new version that has a hole in the
                          sponge. So what happens is when you fill it and you
                          use it all of the detergent comes out. So so I cannot
                          find another Scotch Brite brand that doesn't have the
                          stupid hole in the sponge. So I bought an
                          off-off-broadway and from Amazon of course which is 20
                          pieces for six bucks because I bought the cheapest
                          thinking, they're Okay. So the first question is, what
                          type of cleaning tools? Do you currently use to wash
                          your dishes in your sink? So I'm really embarrassed to
                          admit that sponges are kind of the same to me. They
                          get smelly, they get kind of stinky, you have to throw
                          them away. I actually try to sanitize them in the
                          microwave because that's supposed to be a hack. So I
                          ended up buying like a Honey pack for 10 bucks through
                          Amazon, some off-brand. Now, the thing that my husband
                          uses a lot is that wand where you put the detergent
                          in. So used to be a Scotch Brite brand and then they
                          decide to come out with a new version that has a hole
                          in the sponge. So what happens is when you fill it and
                          you use it all of the detergent comes out. So so I
                          cannot find another Scotch Brite brand that doesn't
                          have the stupid hole in the sponge. So I bought an
                          off-off-broadway and from Amazon of course which is 20
                          pieces for six bucks because I bought the cheapest
                          thinking, they're
                        </div>

                        <div className="my-3">
                          <h6 className="fw-bold text_dark">
                            Keywords & Topics
                          </h6>
                          <div className="mb-2">
                            <div className="tabview-vertical">
                              <TabView className="flex-grow-1">
                                <TabPanel header="All Topics">
                                  <div className="d-flex gap-2 flex-wrap">
                                    {breadcrumbsItems?.map(
                                      (breadcrumbsItem, key) => (
                                        <div
                                          className="typescript-breadcrumb"
                                          key={key}
                                        >
                                          <span>{breadcrumbsItem.label}</span>
                                        </div>
                                      ),
                                    )}
                                  </div>
                                </TabPanel>
                                <TabPanel header="Dental Equipment">
                                  Dental Equipment content here.
                                </TabPanel>
                                <TabPanel header="Teeth">
                                  Teeth content here.
                                </TabPanel>
                              </TabView>
                            </div>
                          </div>
                        </div>
                      </TabPanel>
                    </TabView>
                  </div>
                ) : (
                  ""
                )}

                {selectedTranscript === "Sentiments/Emotions & Entities" ? (
                  <>
                    <div className="row">
                      <div className="my-2 col-md-6">
                        <div className="p-3">
                          <h5 className="text_dark fw-500 mb-3">Sentiment</h5>
                          <div className="d-flex align-items-center">
                            <span>Positive</span>
                            <div className="mx-2 w-100">
                              <ProgressBar
                                color="#002133"
                                style={{ height: "16px" }}
                                value={67}
                                showValue={false}
                              />
                            </div>
                            <span>0.67</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <Divider />
                    <div className="row">
                      <div className="my-2 col-md-6">
                        <div className="p-3">
                          <h5 className="text_dark fw-500 mb-3">Emotions</h5>
                          <div className="d-flex align-items-center">
                            <span>Joy</span>
                            <div className="mx-2 w-100">
                              <ProgressBar
                                color="#002133"
                                style={{ height: "16px" }}
                                value={0.63}
                                showValue={false}
                              />
                            </div>
                            <span>0.63</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <Divider />
                    <div className="my-2">
                      <div className="p-3">
                        <h5 className="text_dark fw-500 mb-3">Entities</h5>
                        <table className="table table-borderless mb-0 clientsTable">
                          <thead>
                            <tr style={{ borderBottom: "1px solid #ccc" }}>
                              <th className="text_dark">Name</th>
                              <th>Type</th>
                              <th style={{ width: "50%" }}>Score</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>Chris Colgate</td>
                              <td>Person</td>
                              <td>
                                <div className="d-flex align-items-center">
                                  <div className="mx-2 w-100">
                                    <ProgressBar
                                      color="#002133"
                                      style={{ height: "16px" }}
                                      value={0.96}
                                      showValue={false}
                                    />
                                  </div>
                                  <span>0.94</span>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>Max Fresh</td>
                              <td>Person</td>
                              <td>
                                <div className="d-flex align-items-center">
                                  <div className="mx-2 w-100">
                                    <ProgressBar
                                      color="#002133"
                                      style={{ height: "16px" }}
                                      value={0.94}
                                      showValue={false}
                                    />
                                  </div>
                                  <span>0.94</span>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </>
                ) : (
                  ""
                )}
              </TabPanel>
              <TabPanel header="Q&A">
                <p className="small text-muted">
                  [Sentiment analysis goes here]
                </p>
              </TabPanel>
              <TabPanel header="Objects">
                <div className="d-flex align-items-center flex-wrap gap-2 my-2">
                  {breadcrumbsItems?.map((breadcrumbsItem, key) => (
                    <div className="typescript-breadcrumb" key={key}>
                      <span>{breadcrumbsItem.label}</span>
                    </div>
                  ))}
                </div>
              </TabPanel>
              <TabPanel header="Notes">
                <div className="my-2">
                  <label className="mb-1 fs-14">Enter Notes:</label>
                  <InputTextarea
                    autoResize
                    value={""}
                    onChange={(e) => console.log(e.target.value)}
                    rows={8}
                    className="w-100 inputField fs-14"
                  />
                  <small>Max 1000 characters.</small>

                  <div className="d-flex justify-content-center gap-2 mt-4 mb-5">
                    <Button
                      label="Cancel"
                      className="px-4 py-2 fw-bold cancel"
                      onClick={() => console.log("cancel")}
                    />
                    <Button
                      label={
                        <>
                          Save
                          {/* {isSubmitting && (
                            <ProgressSpinner
                              style={{
                                width: "20px",
                                height: "20px",
                                marginLeft: "8px",
                              }}
                              strokeWidth="4"
                              fill="transparent"
                              animationDuration=".5s"
                            />
                          )} */}
                        </>
                      }
                      className="px-4 py-2 fw-bold createClientBtn d-flex align-items-center"
                      onClick={() => console.log("save")}
                    />
                  </div>
                </div>
              </TabPanel>
            </TabView>
          </div>
        </div>
      </section>
    </div>
  );
};

export default VideoAudioXmotType;
